<template>
<div id="APIkeyboard">  

  <b-input-group id="phoneticTranscriptionInput">
    <b-form-input type="text" size="lg" id="apiInputTxt"></b-form-input>
    <b-input-group-append>
      <b-button variant="success" @click="validatePhoneticTranscription()">Valider</b-button>
    </b-input-group-append>
  </b-input-group>
  <br>
  <div class="overflow-auto" id="keyboard">
      <h6>Clavier principal</h6>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɑ')">&#593;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɐ')">&#592;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɒ')">&#594;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('æ')">&#230;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɓ')">&#595;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ʙ')">&#665;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('β')">&#946;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɔ')">&#596;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɕ')">&#597;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ç')">&#231;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɗ')">&#599;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɖ')">&#598;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ð')">&#240;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ʤ')">&#676;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ə')">&#601;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɘ')">&#600;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɚ')">&#602;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɛ')">&#603;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɜ')">&#604;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɝ')">&#605;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɞ')">&#606;</b-button>
  <br>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɟ')">&#607;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ʄ')">&#644;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɡ')">&#609;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɠ')">&#608;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɢ')">&#610;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ʛ')">&#667;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɦ')">&#614;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɧ')">&#615;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ħ')">&#295;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɥ')">&#613;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ʜ')">&#668;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɨ')">&#616;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɪ')">&#618;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ʝ')">&#669;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɭ')">&#621;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɬ')">&#620;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɫ')">&#619;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɮ')">&#622;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ʟ')">&#671;</b-button>
  <br>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɱ')">&#625;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɯ')">&#623;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɰ')">&#624;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ŋ')">&#331;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɳ')">&#627;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɲ')">&#626;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɴ')">&#628;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ø')">&#248;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɵ')">&#629;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɸ')">&#632;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('θ')">&#952;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('œ')">&#339;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɶ')">&#630;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ʘ')">&#664;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɹ')">&#633;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɺ')">&#634;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɾ')">&#638;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɻ')">&#635;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ʀ')">&#640;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ʁ')">&#641;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɽ')">&#637;</b-button>
  <br>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ʂ')">&#642;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ʃ')">&#643;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ʈ')">&#648;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ʧ')">&#679;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ʉ')">&#649;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ʋ')">&#651;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ʊ')">&#650;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ʌ')">&#652;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɣ')">&#611;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ɤ')">&#612;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ʍ')">&#653;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('χ')">&#967;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ʎ')">&#654;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ʏ')">&#655;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ʑ')">&#657;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ʐ')">&#656;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ʒ')">&#658;</b-button>
  <br>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ʔ')">&#660;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ʡ')">&#673;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ʕ')">&#661;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ʢ')">&#674;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ǀ')">&#448;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ǁ')">&#449;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ǂ')">&#450;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" @click="addChar('ǃ')">&#451;</b-button>
  <br>
  <br>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="accent principal" @click="addChar('ˈ')">&#712;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="accent secondaire" @click="addChar('ˌ')">&#716;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="marque de longueur" @click="addChar('ː')">&#720;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="longueur moyenne" @click="addChar('ˑ')">&#721;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="éjective" @click="addChar('ʼ')">&#700;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="rhotacisation" @click="addChar('ʴ')">&#692;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="aspiré" @click="addChar('ʰ')">&#688;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="aspiré soufflé" @click="addChar('ʱ')">&#689;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="palatalisé" @click="addChar('ʲ')">&#690;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="labialisé" @click="addChar('ʷ')">&#695;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="velarisé" @click="addChar('ˠ')">&#736;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="pharyngalisé" @click="addChar('ˤ')">&#740;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="rhotacisé" @click="addChar('˞')">&#734;</b-button>
  <br>
  <br>
  <h6>Diacritiques</h6>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="sourde" @click="addChar('̊ ')">&nbsp;&#778;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="extra court" @click="addChar('̆ ')">&nbsp;&#774;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="ton très haut" @click="addChar('̋ ')">&nbsp;&#779;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="centralisée" @click="addChar('̈ ')">&nbsp;&#776;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="vélarisation ou pharyngalisation" @click="addChar('̴ ')">&nbsp;&#820;</b-button>
  <!-- div variant="transparent" @click="addChar('&#619;')">&nbsp;&#619;" -->
  <b-button class="apiKeyboardBtn"  variant="transparent" title="mi centralisée" @click="addChar('̽ ')">&nbsp;&#829;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="pas de détente audible" @click="addChar('̚ ')">&nbsp;&#794;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="nasalisation" @click="addChar('̃ ')">&nbsp;&#771;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="ton haut" @click="addChar('́ ')">&nbsp;&#769;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="ton moyen" @click="addChar('̄ ')">&nbsp;&#772;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="ton bas" @click="addChar('̀ ')">&nbsp;&#768;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="ton très bas" @click="addChar('̏ ')">&nbsp;&#783;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="ton montant" @click="addChar('̌ ')">&nbsp;&#780;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="ton descendant" @click="addChar('̂ ')">&nbsp;&#770;</b-button>
  <br>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="sourde" @click="addChar('̥ ')">&nbsp;&#805;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="soufflé" @click="addChar('̤ ')">&nbsp;&#804;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="dental" @click="addChar('̪ ')">&nbsp;&#810;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="sonore" @click="addChar('̬ ')">&nbsp;&#812;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="voix cassée" @click="addChar('̰ ')">&nbsp;&#816;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="apical" @click="addChar('̺ ')">&nbsp;&#826;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="linguolabial" @click="addChar('̼ ')">&nbsp;&#828;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="laminal" @click="addChar('̻ ')">&nbsp;&#827;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="plus arrondie" @click="addChar('̹ ')">&nbsp;&#825;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="moins arrondie" @click="addChar('̜ ')">&nbsp;&#796;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="avancée" @click="addChar('̟ ')">&nbsp;&#799;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="rétractée" @click="addChar('̠ ')">&nbsp;&#800;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="élévation" @click="addChar('̝ ')">&nbsp;&#797;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="syllabique" @click="addChar('̩ ')">&nbsp;&#809;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="abaissement" @click="addChar('̞ ')">&nbsp;&#798;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="non syllabique" @click="addChar('̯ ')">&nbsp;&#815;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="avancement de la racine de la langue" @click="addChar('̘ ')">&nbsp;&#792;</b-button>
  <b-button class="apiKeyboardBtn"  variant="transparent" title="rétraction de la racine de la langue" @click="addChar('̙ ')">&nbsp;&#793;</b-button>
  </div>
</div>
</template>

<script>
export default {
  name: 'APIKeyboard',
  data() {
    return {
      apiInput: null
    }
  },
  methods: {
    addChar: function(char) {
      this.apiInput = document.querySelector("#apiInputTxt");
      console.log(" selectionStart" + this.apiInput.selectionStart);
      console.log("type " + typeof this.apiInput.selectionStart);
      // if (document.selection) {
        // ce if ne semble servir à rien on n'y passe jamais
      //   console.log("document.selection");
      //   apiInput.focus();
      //   range = document.selection.createRange();
      //   range.text = char;
      //   range.select();
      // }
      // else if (apiInput.selectionStart || apiInput.selectionStart === 0) {
           let startPos = this.apiInput.selectionStart;
           let endPos = this.apiInput.selectionEnd;
           console.log("start " + startPos + " end " + endPos);
           let cursorPos = startPos;
           this.apiInput.value = this.apiInput.value.substring(0, startPos)
            + char
            + this.apiInput.value.substring(endPos, this.apiInput.value.length);
            // on ne passe pas par la variable liée stringAPI comme ci-dessous car sinon le caret est mis systématiquement
            // en fin du texte après l'ajout
            // this.stringAPI = this.stringAPI.substring(0, startPos)
            // + char
            // + this.stringAPI.substring(endPos, this.stringAPI.length);
            cursorPos += 1;
            this.apiInput.focus();
            this.apiInput.selectionStart = cursorPos;
            this.apiInput.selectionEnd = cursorPos;
      // }
      // else {
      // ce else aussi ne semble jamais être exécuté
      //   console.log("append");
      //   this.stringAPI += char;
      //   apiInput.focus();
      // }
    },
    validatePhoneticTranscription: function() {
      this.$store.commit('UPDATE_API_KEYBOARD_VALUE', this.apiInput.value)
    }

  }
}
</script>
<style>
.apiKeyboardBtn {
   font-size: 1.5rem;
   color: white;
 }
 
#modal-2 > div {
  margin-left: 20px;
  margin-top: 6%;
}
#modal-2___BV_modal_content_ {
  width: 600px;
  color: white;
  background-color: rgba(128, 0, 0, 0.9) !important;
}
#keyboard {
  height: 40em;
  overflow: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/commons/APIKeyboard.vue